module.exports = __webpack_public_path__ + "assets/img/verify.7300eda5.png";